import { useTranslation } from 'react-i18next';

import { useUserModules } from '@utils/hooks/useUserModules';

import { getPath } from '@services/RouteService/paths';

import { Link, Navigation } from './NavLinks.styled';

export const NavLinks = () => {
    const { t } = useTranslation();

    const { data } = useUserModules();
    const modules = data?.user.tenant?.modules;

    return (
        <Navigation>
            {modules?.cases && (
                <Link
                    className={(isActive) => (isActive ? 'active' : '')}
                    data-testid="k537hDC"
                    to={getPath({ path: '/incidents' })}
                >
                    {t('MESSAGING_TEXT')}
                </Link>
            )}
            {modules?.surveys && (
                <Link
                    className={(isActive) => (isActive ? 'active' : '')}
                    data-testid="Igax9WX"
                    to={getPath({ path: '/survey/list' })}
                >
                    {t('SURVEY_TEXT')}
                </Link>
            )}
            {modules?.disclosures && (
                <Link
                    className={(isActive) => (isActive ? 'active' : '')}
                    data-testid="8bUHAzD"
                    to={getPath({ path: '/disclosure/list' })}
                >
                    {t('DISCLOSURE_TEXT')}
                </Link>
            )}
        </Navigation>
    );
};
